import {getToken} from "../Utils/Common";

export function getOrganisations() {
        return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}getallcompanyinfos`,
    //return fetch(`${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/companies`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': getToken(),
            },
        })
        .then(response => response.json()).then(data => {return data})
        .catch((error) => {
            console.error('Error:', error);
        })
}

// export function getOrganisations() {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/companies`,
//         {
//             method: 'GET',
//             headers: {
//                 'Authorization': 'Bearer ' + getToken(),
//             },
//         })
//         .then(response => response.json()).then(data => {return data})
//         .catch((error) => {
//             console.error('Error:', error);
//         })
// }

// export function changeProdStatus(companyInfo) {
//     let link=`${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/prodstatus`;
//     return fetch(link,
//         {
//             method: 'PUT',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': 'Bearer ' + getToken(),
//             },
//             body: companyInfo
//         })
//         .then(function (response) {
//             return response.json();
//         })
//         .then(data => {alert(data.message); return data})
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }


export function changeProdStatus(companyInfo) {
    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}changeproductstatus`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': getToken(),
            },
            body: companyInfo
        })
        .then(function (response) {
            return response.json();
        })
        .then(data => {return data})
        .catch((error) => {
            console.error('Error:', error);
        });
}



export function changeCompanyStatus(companyInfo) {

    //let link=`${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/companies`
    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}changecompanystatus`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': getToken(),
            },
            body: JSON.stringify(companyInfo)
        })
        .then(function (response) {
            return response.json();
        })
        .then(data => data)
        .catch((error) => {
            console.error('Error:', error);
        });
}

export async function handleCompanyStatusChange(event, companyDetails){
        event.preventDefault();
        ["cm_web", "cm_logo", "cm_n", "tot_emp"].forEach(e => delete companyDetails[e]);
        companyDetails["cm_st"] = event.target.checked;
        await changeCompanyStatus(companyDetails);
        setTimeout(function () {
            window.location.reload(0.5);
        }, 500);
    }








// export function changeCompanyStatus(companyInfo) {
//     let link=`${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/companies`
//     return fetch(link,
//         {
//             method: 'PUT',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': 'Bearer ' + getToken(),
//             },
//             body: JSON.stringify(companyInfo)
//         })
//         .then(function (response) {
//             return response.json();
//         })
//         .then(data => data)
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }

// export async function handleCompanyStatusChange(event, companyDetails){
//         event.preventDefault();
//         ["cm_web", "cm_logo", "cm_n", "tot_emp"].forEach(e => delete companyDetails[e]);
//         companyDetails["cm_st"] = event.target.checked;
//         await changeCompanyStatus(companyDetails);
//         setTimeout(function () {
//             window.location.reload(0.5);
//         }, 500);
//     }

export async function handleProdAppStatusChange(event, companyDetails){
        event.preventDefault();
        companyDetails["cm_st_app"] = event.target.checked;
        const st = companyDetails['cm_id'];
        let prodstatus_info = {
            cm_st_app:event.target.checked,
            cm_id: st
        };
        await changeProdStatus(JSON.stringify(prodstatus_info));
        setTimeout(function () {
            window.location.reload(0.5);
        }, 500);
    }

export async function handleProdLvStatusChange(event, companyDetails){
        event.preventDefault();
        companyDetails['cm_st_lv']=event.target.checked;
        const st = companyDetails['cm_id'];
        let prodstatus_info = {
            cm_st_lv:event.target.checked,
            cm_id: st
        };
        await changeProdStatus(JSON.stringify(prodstatus_info));
        setTimeout(function () {
            window.location.reload(0.5);
        }, 500);
    }

// export function saveNewCompanyData(companyData) {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/companies`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': 'Bearer ' + getToken(),
//         },
//         body: JSON.stringify(companyData)
//     })
//         .then(function (response) {
//             return response.json();
//         })
//         .then(function (data) {
//             return data;
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }


export function saveNewCompanyData(companyData) {

    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}savecompanydata`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken(),
        },
        body: JSON.stringify(companyData)
    })
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            return data;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}
